export default {
    methods: {
        // Dokleja pierwszą kolumnę "Nr zgłoszenia", gdy którykolwiek wiersz listy ma numer
        // (serwer zwraca numer tylko u klientów z włączoną numeracją).
        withSignalNumber(headers, items) {
            if (Array.isArray(items) && items.some(item => item != null && item.signalNumber != null)) {
                return [{ text: 'Nr zgłoszenia', value: 'signalNumber', sortable: false }, ...headers];
            }

            return headers;
        }
    }
};
